import { useEffectOnce } from 'react-use';

export const useResetRootFontSize = () => {
  useEffectOnce(() => {
    const root = document.documentElement;

    const prev = root.style.fontSize;

    root.style.fontSize = '14px';

    return () => {
      root.style.fontSize = prev;
    };
  });
};
